<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
       <div class="bg-white page-border page-min-h">
          <div class="row row-replace add-m-b">
             <div class="col-md-6 col-9 col-p">
                <small class="h5">Refyne App / {{category}}</small>
             </div>
             <div class="col-md-6 col-3 top-corner-items col-p">
                <button class="btn btn-primary btn-sm" (click)="back()"><i class="fa fa-arrow-left"></i> Back</button>
             </div>
          </div>
          <div class="row"></div>
          <section class="row">
             <section class="col-md-6">
                <table class="table bg-primary text-white m-0 default-table">
                   <tr>
                      <th width="50">Sr.No</th>
                      <th>Name</th>
                      <th width="100">Action</th>
                   </tr>
                </table>
                <div class="table-responsive">
                   <table class="table default-table">
                      <tr class="bg-primary text-white">
                         <td colspan="3"></td>
                      </tr>
                      <tr *ngFor="let item of hseDocuments; let i = index">
                         <td width="50">{{i+1}}</td>
                         <td>{{item.name}}</td>
                         <td width="100"><a  
                             href={{item.url}}
                            target="_blank"> Document View</a></td>
                      </tr>
                   </table>
                </div>
             </section>
          </section>
       </div>
    </div>
 </div>
 <!-- /Page Wrapper -->
 
 
 